export const LOCAL_STORAGE_TEMPLATE_GUIDE = 'templateGuide';

export const LOCAL_STORAGE_ID = 'lc';
